import React, { useState, useEffect } from 'react';
import { Form, Input, Typography, Alert } from 'antd';
//import { toLatLon, toMGRS } from 'geo-coord-utils';
import { MGRS } from "@ngageoint/mgrs-js";

const { Text } = Typography;
var utmObj = require('utm-latlng');

const MGRSCoordinateInput = ({ form, onEnter }) => {
    const [latLng, setLatLng] = useState(null);
    const [error, setError] = useState(null);
    const [UTM, setUTM] = React.useState(null);
    const [formKey, setFormKey] = useState(0);

    //function for parsing MGRS and converting to UTM coordinates
    const ConvertMGRS2UTM = async (value) => {
        try {

            //MGRS-->UTM
            const mgrs2 = MGRS.parse(value);
            const utm2 = await mgrs2.toUTM();
            console.log('UTM:', utm2);

            //UTM-->MGRS
            const mgrs5 = utm2.toMGRS();
            console.log('MGRS:', mgrs5);
            form.setFieldsValue({ value });

            //UTM-->Latlong
            var utm = new utmObj(); //Default Ellipsoid is 'WGS 84'
            const latLng = utm.convertUtmToLatLng(utm2.easting, utm2.northing, utm2.zone, mgrs5.band);

            console.log('UTM to Lat/Lon:', latLng);
            setUTM({ ...utm2, ...latLng });
            setLatLng({ ...latLng });
            onEnter({ ...utm2, latitude: latLng.lat, longitude: latLng.lng });
            setFormKey(formKey + 1);

        } catch (error) {
            setError(error);
            console.log('Error:', error);
        }

    }

    //rerender form
    useEffect(() => {
        //console.log('render');
        form.setFieldsValue(UTM);
    }, [form, UTM]);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            //console.log('pressed enter');
            // You can call your custom function here
            ConvertMGRS2UTM(event.target.value);

            event.preventDefault(); // ป้องกันฟอร์ม submit


        }
    };

    return (
        <>
            {form && (
                <>
                    <Form.Item
                        name="mgrs"
                        label="พิกัด MGRS"
                        rules={[{ required: false, message: 'กรุณากรอกพิกัด MGRS' }]}
                    >
                        <Input placeholder="47PQU1234567890" onKeyPress={handleKeyPress} value="48PVB8821375810" />
                    </Form.Item>

                    {error && <Alert type="error" message={error} showIcon />}
                    {latLng && (
                        <div style={{ marginBottom: 16 }}>
                            <Text type="secondary">ละติจูด: {latLng.lat}</Text><br />
                            <Text type="secondary">ลองจิจูด: {latLng.lng}</Text>
                        </div>
                    )}

                </>
            )}
        </>
    );
};

export default MGRSCoordinateInput;
